// extracted by mini-css-extract-plugin
module.exports = {"slider":"scss_slider__3_jwf"};